var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoNewsrodeoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 107,
    viewBox: "0 0 258 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_8165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70.86V22.67C0.0184751 16.6615 2.41421 10.9045 6.66383 6.65677C10.9134 2.40903 16.6715 0.0158252 22.68 0H76.68V48.19C76.6642 54.1976 74.2706 59.9546 70.0226 64.2026C65.7746 68.4507 60.0176 70.8442 54.01 70.86H0Z",
    fill: "#F7A823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 8.51001C18.9227 8.51266 15.32 10.0064 12.6632 12.6632C10.0064 15.3201 8.51266 18.9227 8.51001 22.68V62.37H54.04C57.7965 62.3647 61.3976 60.8701 64.0539 58.2139C66.7101 55.5576 68.2047 51.9565 68.21 48.2V8.51001H22.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.94 30.77H36.13V53.27H29.13L19.89 34.51H19.74L20.09 53.32H15.9V30.82H22.83L32.17 49.63H32.29L31.94 30.77Z",
    fill: "#F7A823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36 45.83V53.27H42.16V30.77H53.31C58.09 30.89 59.92 32.42 59.92 37.52C59.92 40.85 59.75 43.28 56.05 43.85V43.97C59.05 44.24 59.75 45.89 59.75 49.07V53.27H55.56V49.07C55.56 47.18 54.8 45.86 52.79 45.83H46.36ZM51.89 42.14C54.97 42.14 55.73 41.51 55.73 38.21C55.73 34.91 55.18 34.46 52.18 34.46H46.36V42.14H51.89Z",
    fill: "#F7A823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.89 102.22L4.51002 87.02H0.27002V106.11H3.64002V90.91L19.02 106.11H23.27V87.02H19.89V102.22Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59 97.79H46.88V94.79H32.59V90.02H47.47V87.02H29.22V106.11H47.56V103.11H32.59V97.79Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.42 102.01L68.81 87.02H65.07L59.39 101.94L53.6 87.02H50.2L57.57 106.11H61.32L66.94 91.14L72.56 106.11H76.31L83.68 87.02H80.28L74.42 102.01Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.03 94.9101H94.03C90.32 94.9101 90.16 94.1801 90.16 92.5401C90.16 90.2001 90.96 89.8101 95.87 89.8101H98.4C104.4 89.8101 104.4 90.2001 104.47 92.7201V93.2101H107.69V92.0901C107.69 88.2401 105.56 86.8101 99.82 86.8101H94.7C89.77 86.8101 86.92 87.7201 86.92 92.3601C86.92 97.8701 90.21 98.1101 97.05 98.1101H101.56C104.46 98.1101 104.9 98.6401 104.9 100.46C104.9 102.6 104.32 103.31 100.9 103.31H93.53C90.4 103.31 90.15 102.31 90.15 101.19V99.4101H86.91V101.24C86.91 106.31 91.84 106.31 93.91 106.31H100.51C103.34 106.31 108.07 106.31 108.07 101.04V99.8601C108.11 96.4401 105.93 94.9101 101.03 94.9101Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26 87.01H127.72V106.11H131.09V98.96H142.19C144.19 98.96 145.19 99.23 145.19 101.64V106.11H148.45V100.99C148.512 100.321 148.378 99.6493 148.063 99.056C147.749 98.4628 147.268 97.9741 146.68 97.65C147.75 97.19 148.68 96.22 148.68 94.11V92.64C148.64 88.99 147.62 87.01 142.26 87.01ZM131.09 90.01H141.45C144.94 90.01 145.29 90.64 145.29 92.19V93.84C145.29 95.18 144.75 95.96 142.03 95.96H131.09V90.01Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.66 86.8101H160.54C155.74 86.8101 153.78 88.9201 153.78 94.0901V99.0401C153.78 104.2 155.78 106.31 160.54 106.31H170.66C175.46 106.31 177.42 104.2 177.42 99.0401V94.0901C177.45 88.9201 175.45 86.8101 170.66 86.8101ZM174.04 93.1601V99.9601C174.04 102.34 173.04 103.31 170.41 103.31H160.78C158.21 103.31 157.16 102.31 157.16 99.9601V93.1601C157.16 90.7801 158.21 89.8101 160.78 89.8101H170.45C172.99 89.8101 174.04 90.7801 174.04 93.1601Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59 87.01H182.9V106.11H197.52C203.52 106.11 205.59 103.7 205.59 96.56C205.59 89.16 203.8 87.01 197.59 87.01ZM197.84 103.11H186.28V90.01H198.22C200.56 90.01 202.22 90.42 202.22 95.69V97.51C202.21 102.71 200.45 103.11 197.84 103.11Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6 97.79H228.89V94.79H214.6V90.02H229.47V87.02H211.22V106.11H229.56V103.11H214.6V97.79Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.03 86.8101H240.91C236.11 86.8101 234.15 88.9201 234.15 94.0901V99.0401C234.15 104.2 236.15 106.31 240.91 106.31H251.03C255.83 106.31 257.79 104.2 257.79 99.0401V94.0901C257.79 88.9201 255.83 86.8101 251.03 86.8101ZM254.41 93.1601V99.9601C254.41 102.34 253.41 103.31 250.79 103.31H241.15C238.58 103.31 237.53 102.31 237.53 99.9601V93.1601C237.53 90.7801 238.58 89.8101 241.15 89.8101H250.79C253.36 89.8101 254.45 90.7801 254.45 93.1601H254.41Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_8165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.79,
    height: 106.31,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewsrodeoMobile);
export default __webpack_public_path__ + "static/media/logo_newsrodeo_mobile.bb18f623c8eaf0c9847eddaae83074de.svg";
export { ForwardRef as ReactComponent };